import "./GetInTouch.module.css";
import Header from "@/reusable_sections/Header";
import ContactezNosExperts from "./sections/ContactezNosExperts";
import LocateOurStudio from "./sections/LocateOurStudio";
import FooterInfo from "@/reusable_sections/Footer";
export default function GetInTouchPage() {
  return <div>
      <Header />
      <ContactezNosExperts />
      <LocateOurStudio />
      <FooterInfo />
    </div>;
}